export default __webpack_public_path__ + "static/media/Andy_Jones-make_it_simple.d0dfebab.png";